import { render, staticRenderFns } from "./Search1.vue?vue&type=template&id=39cae9a8"
import script from "./Search1.vue?vue&type=script&lang=ts"
export * from "./Search1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports